import type { ReactElement } from "react";

import { translate } from "app/filters/i18nFilter";
import { ExportVariantsDropdownItem } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import type { CRMEntity } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";
import ContactsDynamicsExportItemContainer from "app/pages/sales-intelligence/sub-modules/management/containers/ContactsDynamicsExportItem/ContactsDynamicsExportItemContainer";
import ContactsHubSpotExportItemContainer from "app/pages/sales-intelligence/sub-modules/management/containers/ContactsHubSpotExportItem/ContactsHubSpotExportItemContainer";
import ContactsSalesforceExportItemContainer from "app/pages/sales-intelligence/sub-modules/management/containers/ContactsSalesforceExportItem/ContactsSalesforceExportItemContainer";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";

interface IProps {
    isUseLockedIcon?: boolean;
    isExportDisabled: boolean;
    disabledExportTooltip: string;
    onCRMExport: (destination: Integration, as?: CRMEntity) => void;
    onExcelExport?: VoidFunction;
    withExcelExport?: boolean;
}

const ContactsExportCommonItems = ({
    isExportDisabled,
    isUseLockedIcon = true,
    disabledExportTooltip,
    onExcelExport,
    onCRMExport,
    withExcelExport = true,
}: IProps): ReactElement[] => {
    const tooltipDisabledContent = isExportDisabled ? disabledExportTooltip : undefined;

    return [
        ...(withExcelExport
            ? [
                  <ExportVariantsDropdownItem
                      key="excel"
                      iconName="document-download-icon"
                      text={translate("si.contacts_search.action.export.variant.excel.text")}
                      variant="excel"
                      onClick={onExcelExport}
                      isDisabled={isExportDisabled}
                      isUseLockedIcon={isUseLockedIcon}
                      tooltipDisabledContent={tooltipDisabledContent}
                  />,
              ]
            : []),
        <ContactsSalesforceExportItemContainer
            key="salesforce"
            tooltipDisabledContent={tooltipDisabledContent}
            isUseLockedIcon={isUseLockedIcon}
            onClick={onCRMExport}
            isExportDisabled={isExportDisabled}
        />,
        <ContactsHubSpotExportItemContainer
            key="hubspot"
            tooltipDisabledContent={tooltipDisabledContent}
            isUseLockedIcon={isUseLockedIcon}
            onClick={onCRMExport}
            isExportDisabled={isExportDisabled}
        />,
        <ContactsDynamicsExportItemContainer
            key="dynamics"
            tooltipDisabledContent={tooltipDisabledContent}
            isUseLockedIcon={isUseLockedIcon}
            onClick={onCRMExport}
            isExportDisabled={isExportDisabled}
        />,
    ];
};

export default ContactsExportCommonItems;
